import React from 'react';
import { useSingleSaleSuccessStyles } from 'components/Payments/SingleSale/Success/SingleSaleSuccess.styles';
import { useCommonStyles } from 'components/UI/CommonStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { Typography } from '@material-ui/core';
import { PriceFormat } from 'components/UI';
import { Button } from 'components/UI';
import clsx from 'clsx';
import { Order } from '@spike/order-model';
import { GenericOrderItem } from 'components/Payments/SingleSale/SingleSale';

interface SaleSuccessProps {
    order: Order;
    className?: string;
    //
    onBack: () => void;
}

export const SingleSaleSuccess: React.FC<SaleSuccessProps> = props => {
    const classes = useSingleSaleSuccessStyles();

    const commonClasses = useCommonStyles();

    const total = React.useMemo(() => {
        return [
            ...props.order.items.appointments,
            ...props.order.items.products,
            ...props.order.items.addOnServices,
            ...props.order.items.customs
        ].reduce((acc, item: GenericOrderItem) => {
            return acc + Number(item.orderItem.total || 0);
        }, 0);
    }, [props.order.items]);

    return (
        <>
            <div className={clsx(props.className, classes.container)}>
                <button
                    type="button"
                    className={classes.closeBtn}
                    onClick={props.onBack}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>

                <div className={clsx(props.className, classes.boxContainer)}>
                    <FontAwesomeIcon
                        icon={faCircleCheck}
                        className={classes.icon}
                    />
                    <Typography className={clsx(classes.title)}>Sale Successful!</Typography>
                    <Typography className={clsx(classes.typoMessage)}>
                        Payment received on {props.order.createdAt.format('dddd, DD MMM YYYY')}.
                    </Typography>

                    <Typography className={clsx(commonClasses.typo28_500_green, commonClasses.typo_center)}>
                        <PriceFormat price={total} />
                    </Typography>
                    <Typography className={clsx(classes.totalPaid)}>Total Paid</Typography>
                </div>

                <Button
                    color="black"
                    label="Make Another Sale"
                    className={classes.button}
                    onClick={props.onBack}
                />
            </div>
        </>
    );
};
